<template>
  <div class="home">
    <UserList v-show="listView" @newUser="onClickNewFromList" @editUser="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <UserForm v-show="formView" :user="user" @backClicked="onBackChild"/>
  </div>
</template>

<script>
// @ is an alias to /src
import UserList from '@/components/user/UserList.vue'
import UserForm from '@/components/user/UserForm.vue'

export default {
  name: 'User',
  components: {
    UserList,
    UserForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      user: {
        id: null,
        username: null,
        name: null,
        email: null,
        password: null,
        branch_no: null,
        position_id: null,
        birthday: null,
        birthplace: null,
        address: null,
        phone: null,
        photo: null,
        company_no: null,
        role_id: [],
        roles: [{
          id: null,
          name: null
        }]
      }
    }
  },
  methods: {
    onClickEditFromList: function (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      console.log(x + '|' + y)
      this.listView = false
      this.formView = true
      this.user = value
    },
    onClickNewFromList: function () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      console.log(x + '|' + y)
      this.listView = false
      this.formView = true
      this.user = {
        id: null,
        username: null,
        name: null,
        email: null,
        password: null,
        branch_no: null,
        position_id: null,
        birthday: null,
        birthplace: null,
        address: null,
        phone: null,
        photo: null,
        company_no: null,
        role_id: [],
        roles: [{
          id: null,
          name: null
        }]
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.user = {
        id: null,
        username: null,
        name: null,
        email: null,
        password: null,
        branch_no: null,
        position_id: null,
        birthday: null,
        birthplace: null,
        address: null,
        phone: null,
        photo: null,
        company_no: null,
        role_id: [],
        roles: [{
          id: null,
          name: null
        }]
      }
      await this.$refs.refreshList.refreshList()
      await window.scrollTo(this.corX, this.corY)
      console.log('window.scrollTo:' + this.corY)
    }
  },
  mounted () {
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getBranchList')
    this.$store.dispatch('getRolesList')
    this.$store.dispatch('getPositionList')
    this.$store.dispatch('getCompanyList')
  }
}
</script>
